<template>
  <b-modal id="two-factor-authentication-modal"
           :title="$t('two_factor_authorization')"
           centered
           size="md"
           @show="onShow"
           @hidden="emit('hide')"
           hide-footer>
    <div v-if="qr">
      <div v-if="!backupCodes">
        <div v-html="$t('twofactor_setup_instructions')"></div>
        <div class="text-center mt-5 mb-4">
          <qrcode-vue :value="qr"
                      v-if="qr"
                      foreground="#111111"
                      :size="160"/>
        </div>
        <div class="text-center">
          <InputGroup :label="$t('code')"
                      :autofocus="true"
                      class="mx-auto w-50"
                      :showErrors="true"
                      validation-id="code"
                      ref="codeInput"
                      :readonly="checkingCode"
                      @input="codeInputHandler"/>
        </div>
      </div>
      <div v-if="backupCodes">
        <div class="text-primary font-weight-bold mb-4">{{ $t('two_factor_authorization_setup_successfully') }}</div>
        <div class="mb-3">
          <div>{{ $t('reserve_codes') }}</div>
          <div class="alert alert-info">{{ backupCodes }}</div>
        </div>
        <div class="text-right">
          <a @click="close"
             class="btn btn-themed-outline btn-themed-squared px-4">
            {{ $t('close') }}
          </a>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script setup>
import {UsersService} from "@/services/api/users.api.service"
import {getCurrentInstance, nextTick, onBeforeMount, ref} from "vue"
import QrcodeVue from "qrcode.vue"
import InputGroup from "@/components/form/InputGroup.vue"
import {useStore} from "vuex"

const emit = defineEmits(['hide'])
const store = useStore()

const qr = ref('')
const codeInput = ref(null)
const backupCodes = ref(null)
const checkingCode = ref(false)
let bvModal = null

defineProps({
  mode: {
    type: String,
    default: 'auth'
  }
})

onBeforeMount(() => {
  const instance = (getCurrentInstance())
  bvModal = instance?.ctx?._bv__modal
})

const onShow = async () => {
  store.commit('cleanValidationErrors')
  try {
    const res = await UsersService.twofactorGenerateQR()
    qr.value = res?.data?.qr_url || null
    if(qr.value) {
      await nextTick()
      console.log('focusing')
      codeInput.value?.focus()
    }
  } catch (e) {
    console.log(e)
  }
}

const codeInputHandler = async (val) => {
  store.commit('cleanValidationErrors')
  if(val.length < 6 || checkingCode.value) return
  checkingCode.value = true
  try {
    const res = await UsersService.twofactorVerifyCode(val)
    backupCodes.value = res?.data?.backup_codes || null
    if(backupCodes.value) {
      store.dispatch('init').then().catch(console.error)
    }
  } catch (e) {
    console.log(e)
  } finally {
    checkingCode.value = false
  }
}

const close = () => {
  bvModal.hide('two-factor-authentication-modal')
}
</script>
